import { createAppTheme } from '@alison/ui';
import { applyHead, currentTenant, TenantProvider } from '@alison/whitelabel/react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { queryClient } from './lib/queryClient.js';
import { TRPCProvider } from './lib/trpc.js';
import { trpcClient } from './lib/trpcClient.js';
import { router } from './router.js';

const rootElement = document.getElementById('root');
if (rootElement === null) {
  throw new Error('Root element #root not found');
}

// Tenant is fixed per page load (hostname), so resolve once and brand the head before React mounts.
const tenant = currentTenant();
applyHead(tenant);
const theme = createAppTheme(tenant.brand);

createRoot(rootElement).render(
  <StrictMode>
    <TenantProvider tenant={tenant}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <QueryClientProvider client={queryClient}>
          <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
            <RouterProvider router={router} />
          </TRPCProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </TenantProvider>
  </StrictMode>,
);
